// packages/web-ui/src/panels/views/InterfaceNode.tsx
//
// W4-S1 — Stub for the `type: 'interface'` discriminator. The full visual
// (UX §6.4.3 legend, "InterfaceFlow" link icon) lands in W4-S2; the shell
// must exist now so React Flow does not warn `Node type 'interface' not found`
// when consuming a fixture that contains one.

import type { JSX } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { InterfaceNodeData } from './layout-builder.js';

export function InterfaceNode({ data, id }: NodeProps): JSX.Element {
  const ifaceData = (data ?? {}) as InterfaceNodeData;
  const label = ifaceData.label ?? ifaceData.name ?? id;

  return (
    <div
      data-kind="interface"
      data-placeholder="true"
      style={{
        position: 'relative',
        width: 120,
        minHeight: 36,
        padding: '6px 10px',
        background: 'var(--tessa-bg-elev)',
        border: '1.5px dashed var(--tessa-border)',
        borderRadius: 6,
        color: 'var(--tessa-fg)',
        fontSize: 11,
        textAlign: 'center',
      }}
    >
      <div style={{ fontStyle: 'italic', fontSize: 9, color: 'var(--tessa-muted)' }}>
        «interface»
      </div>
      <div style={{ fontWeight: 600, fontSize: 11 }}>{label}</div>
      <Handle
        type="target"
        position={Position.Left}
        id={`${label}.t`}
        style={{
          width: 9,
          height: 9,
          background: 'var(--tessa-bg)',
          border: '1.2px solid var(--tessa-border)',
          borderRadius: 0,
        }}
      />
      <Handle
        type="source"
        position={Position.Right}
        id={`${label}.s`}
        style={{
          width: 9,
          height: 9,
          background: 'var(--tessa-bg)',
          border: '1.2px solid var(--tessa-border)',
          borderRadius: 0,
        }}
      />
    </div>
  );
}

export default InterfaceNode;
